
import { supabase } from '@/lib/supabase/client';
import { Shop } from './types';

export async function getShopById(shopId: string): Promise<Shop | null> {
  try {
    const { data, error } = await supabase
      .from('shops')
      .select('*')
      .eq('id', shopId)
      .single();

    if (error) {
      console.error('Error fetching shop:', error);
      return null;
    }

    return data as Shop;
  } catch (error) {
    console.error('Unexpected error fetching shop:', error);
    return null;
  }
}
